/* global google */

import mapStyle from '../../../src/js/modules/map-style';
import neMapStyle from '../../../src/js/modules/ne-map-style';
import mapZoomControl from '../../../src/js/modules/map-zoom-control';
import { markerIcon } from '../location-list/google-maps';

const singleMap = () => {
  const body = document.querySelector('body');
  const brandColor = body.getAttribute('js-brand-color');
  const brand = body.getAttribute('data-brand');

  const elements = document.querySelectorAll('[js-single-map]');
  if (!elements) {
    return;
  }

  let style = brand == 'northlight-estates' ? neMapStyle : mapStyle;

  Array.prototype.forEach.call(elements, el => {
    const lat = Number(el.getAttribute('lat'));
    const lng = Number(el.getAttribute('lng'));
    const markerLink = el.getAttribute('marker-link');

    const map = new google.maps.Map(el, {
      center: { lat, lng },
      styles: style,
      disableDefaultUI: true,
      scrollwheel: false,
      zoom: 14
    });

    const marker = new google.maps.Marker({
      position: map.getCenter(),
      icon: markerIcon,
      map
    });

    marker.addListener('click', function () {
      window.open(markerLink, '_blank');
    });

    mapZoomControl(map, brandColor);
  });
};

export default singleMap;
